import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import { viewSpacePath } from "@circle-react/helpers/urlHelpers";
import { LoaderRow } from "@circle-react-shared/LoaderRow";
import { Loader } from "@circle-react-uikit/Loader";
import { CourseCard } from "./CourseCard";
import { EmptyState } from "./EmptyState";

export interface ListCoursesComponentProps {
  communityMember: any;
  courses?: any[];
  fetchNextPage: () => void;
  hasNextPage?: boolean;
  isLoading?: boolean;
  filter: "all" | "joined";
}

export const ListCoursesComponent = ({
  communityMember,
  courses = [],
  fetchNextPage,
  hasNextPage = false,
  isLoading = false,
  filter,
}: ListCoursesComponentProps) => {
  if (isLoading) {
    return <Loader />;
  }
  if (courses.length === 0) {
    return <EmptyState filter={filter} />;
  }
  return (
    <InfiniteScroll
      style={{ overflow: "initial" }}
      scrollThreshold={0.8}
      next={fetchNextPage}
      hasMore={!!hasNextPage}
      loader={<LoaderRow />}
      dataLength={courses.length}
      scrollableTarget="panel"
    >
      <ol
        className="grid-cols-course-directory m-4 grid max-w-full list-none auto-rows-fr gap-6 lg:m-auto"
        data-testid="directory_courses_grid"
      >
        {courses.map(course => (
          <li key={course.id}>
            <Link to={viewSpacePath({ spaceSlug: course.slug })}>
              <CourseCard course={course} communityMember={communityMember} />
            </Link>
          </li>
        ))}
      </ol>
    </InfiniteScroll>
  );
};
